<h2 mat-dialog-title class="copo-color-orange" translate>{{data.title}}</h2>
<mat-dialog-content [class.compact-content]="data.useCompactContent">
	<div class="copo-simple-dialog-content">
		<div>
			<span translate>{{data.content}}</span>
		</div>
	</div>
</mat-dialog-content>
<mat-dialog-actions class="button-group" [class.compact-actions]="data.useCompactContent">
	<button type="button" mat-button [mat-dialog-close]="false" class="save-cancel-button-block copo-button-font">
		<span translate>filter.cancel</span>
	</button>
	<button type="submit" mat-button [mat-dialog-close]="true"
		[class.wide-confirm-button]="data.useWideConfirmButton"
		class="copo-blue-dark-grey-button">
		<span translate>filter.ok</span>
	</button>
</mat-dialog-actions>